/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import CtaBanner from "./CtaBanner";

export default CtaBanner;
